export default "__VITE_PUBLIC_ASSET__392742b3__"